module.exports = __webpack_public_path__ + "img/tablecell-nocolor.4a7cf3f.svg";